(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomServiceTypeAttributeDetailController', CustomServiceTypeAttributeDetailController);

    CustomServiceTypeAttributeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CustomServiceTypeAttribute'];

    function CustomServiceTypeAttributeDetailController($scope, $rootScope, $stateParams, previousState, entity, CustomServiceTypeAttribute) {
        var vm = this;

        vm.customServiceTypeAttribute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('trakeyeApp:customServiceTypeAttributeUpdate', function(event, result) {
            vm.customServiceTypeAttribute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
